import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManagerParkingTicketsPageRoutingModule } from './manager-parking-tickets-routing.module';

import { ManagerParkingTicketsPage } from './manager-parking-tickets.page';
import { SharedComponentsModule } from 'src/app/components/shared-components.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedComponentsModule,
    TranslateModule,
    ManagerParkingTicketsPageRoutingModule
  ],
  declarations: [ManagerParkingTicketsPage]
})
export class ManagerParkingTicketsPageModule {}
